module.exports = __webpack_public_path__ + "static/media/logo-bodyshock.6edc10bd.svg";